import axios from 'axios'
import setting from '../../config/settings'
import router from '../../router/index'
import * as types from '../../vuex/mutation-types'
import store from '../../vuex/store'

// axios 配置
axios.defaults.timeout = 60000
axios.defaults.baseURL = setting.remoteHost
axios.defaults.withCredentials = true

// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (store.state.common && store.state.common.accessToken) {
      config.headers.common['Authorization'] = `Bearer ${store.state.common.accessToken}`
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 401 清除token信息并跳转到登录页面
          store.commit(types.LOGOUT)
          if (router.currentRoute.path !== '/login') {
            router.replace({
              path: setting.basicURL + '/login',
              query: {redirect: router.currentRoute.fullPath}
            })
          }
      }
    }
    console.log(error) // console : Error: Request failed with status code 402
    return Promise.reject(error)
  }
)
export default axios



// WEBPACK FOOTER //
// ./src/service/auth/http.js